module.exports = __webpack_public_path__ + "static/media/bug.ff047cb1.svg";